<div [class.error]="hasError" [class.transparent]="transparent">
  @if (readonly) {
    <mat-chip-set aria-label="Fish selection">
      @for (item of selectedItems; track item) {
        <mat-chip disableRipple [ngStyle]="getChipStyle(item.color)">
          <div
            [class.ellipsis-text]="item.name.length > 40"
            [matTooltip]="item.name.length > 40 ? item.name : ''"
          >
            {{ item.name }}
          </div>
        </mat-chip>
      }
    </mat-chip-set>
  }
  @if (!readonly) {
    <mat-form-field
      appearance="outline"
      floatLabel="always"
      class="stretch-input"
      subscriptSizing="dynamic"
      [class.filter-mode]="filterMode"
      [class.extra-compact-field]="compactSize"
    >
      @if (label) {
        <mat-label
          >{{ label }}
          @if (required) {
            <span class="required-star">*</span>
          }
        </mat-label>
      }
      <mat-chip-grid #chipList aria-label="selection" [disabled]="disabled">
        <ng-content></ng-content>
        @for (item of selectedItems; track item) {
          <mat-chip-row
            class="person-tag"
            (removed)="remove(item)"
            [ngStyle]="getChipStyle(item.color)"
          >
            <div
              [class.ellipsis-text]="item.name.length > 40"
              [matTooltip]="item.name.length > 40 ? item.name : ''"
            >
              {{ item.name }}
            </div>
            @if (removable) {
              <mat-icon matChipRemove>cancel</mat-icon>
            }
          </mat-chip-row>
        }
        <input
          class="transparent-input"
          matInput
          forbidAngleBrackets
          [placeholder]="placeholder"
          #input
          [formControl]="formCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
          attr.aria-labelledby="{{ ariaLabelledby }}"
        />
      </mat-chip-grid>
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="selected($event)"
      >
        @if (items.length > 0) {
          <div>
            @for (item of filteredItems | async; track item) {
              <div>
                @if (!item.selected) {
                  <mat-option [value]="item" (click)="$event.stopPropagation()">
                    @if (item.icon) {
                      <mat-icon>{{ item.icon }}</mat-icon>
                    }
                    <span>{{ item.name }}</span>
                  </mat-option>
                }
              </div>
            }
          </div>
        }
      </mat-autocomplete>
    </mat-form-field>
    @if (!filterMode && required) {
      <mat-error class="mat-error-multiselect">
        {{ errorMessage }}
      </mat-error>
    }
  }
</div>
